import React from "react";

import BNLogo from "../../assets/bitcoin-navigator/BN-no-fill.png";

const SIZES = {
  lg: 48,
  sm: 20,
};

const BitcoinNavigatorWordmark = ({ size = "lg" }) => (
  <img
    src={BNLogo}
    alt="Bitcoin Navigator"
    style={{ height: SIZES[size] || SIZES.lg, width: "auto", display: "block" }}
  />
);

export default BitcoinNavigatorWordmark;
